export const OPTIONS_CONTACTOS = [
  { label: "No importar", value: "" },
  { label: "NIF", value: "nif" },
  { label: "Razón Social", value: "razonSocial" },
  { label: "Teléfono", value: "telefono" },
  { label: "Email", value: "email" },
  { label: "Código postal", value: "codigoPostal" },
  { label: "Calle", value: "calle" },
  { label: "Población", value: "poblacionNombre" },
]

export const OPTIONS_ACTIVOS = [
  { label: "No importar", value: "" },
  {
    label: "Nombre del activo*",
    value: "nombre",
  },
  {
    label: "Fecha de adquisición (dd/mm/yyyy)*",
    value: "fechaAdquisicion",
  },
  {
    label: "NIF del contacto",
    value: "contactoNif",
  },
  {
    label: "Nombre del contacto",
    value: "contactoNombre",
  },
  {
    label: "Tipo inmovilizado (material/intangible)*",
    value: "tipoInmovilizado",
  },
  {
    label: "Importe*",
    value: "importe",
  },
  {
    label: "Importe pendiente*",
    value: "importePendiente",
  },
  {
    label: "Cuenta contable*",
    value: "cuentaContableActivo",
  },
  {
    label: "Cuenta contable contrapartida",
    value: "cuentaContableContrapartida",
  },
  {
    label: "Concepto de tablas de amortización (ver pestaña Coeficientes)",
    value: "conceptoTablaAmortizacion",
  },
  {
    label: "Período de amortización (mensual/anual)",
    value: "informacionAmortizacionTipoPeriodo",
  },
  {
    label: "Coeficiente",
    value: "informacionAmortizacionCoeficiente",
  },
  {
    label: "Años",
    value: "informacionAmortizacionAnyos",
  },
  {
    label: "Cuenta de amortización acumulada",
    value: "informacionAmortizacionCuentaContableAmortizacionAcumulada",
  },
  {
    label: "Fecha de inicio de amortización en Finanedi",
    value: "fechaInicioAmortizacion",
  },
  {
    label: "Descripción",
    value: "descripcion",
  },
  {
    label: "Número de serie",
    value: "numeroSerie",
  },
  {
    label: "Cuenta de gasto de amortización",
    value: "informacionAmortizacionCuentaContableAmortizacionGasto",
  },
  {
    label: "Número de inventario",
    value: "numeroInventario",
  },
  {
    label: "Código de barras",
    value: "codigoBarras",
  },
  {
    label: "Marca",
    value: "marca",
  },
  {
    label: "Es amortizable (si/no)*",
    value: "esAmortizable",
  },
]

export const downloadFile = (url: string, fileName: string) => {
  const link = document.createElement("a")
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
